// import { animate, stagger } from 'motion'

// animate('#primary-menu .parent-item', { opacity: 1, y: [20, 0] }, { delay: stagger(0.05) })
